import React from 'react'
import { Radio } from 'ic-snacks'
import { spacing } from '@retailer-platform/shared-components'
import { useDashMessage } from 'intl/intl.hooks'

interface RecurringShiftsRadioProps {
  identifier: any
  labelMessageId: any
  value?: string
  selectedValue: any
  onChange: (value: any) => void
  disabled?: boolean
}

export const RecurringShiftsRadio = ({
  identifier,
  labelMessageId,
  value,
  selectedValue,
  onChange,
  disabled,
}: RecurringShiftsRadioProps) => {
  const label = useDashMessage(labelMessageId)

  const handleChange = event => {
    const checkedValue = event.currentTarget.value
    onChange(checkedValue)
  }

  return (
    <Radio
      id={`${identifier}.${value}`}
      name={identifier}
      value={value}
      isSelected={value === selectedValue}
      onChange={handleChange}
      style={{
        wrapEl: { marginRight: spacing.X32, marginBottom: spacing.X12 },
        label: { fontFamily: 'Eina 01', fontSize: '15px', fontWeight: 600, color: '#72767E' },
      }}
      isDisabled={disabled}
      data-testid={`${identifier}.${value}`}
    >
      {label}
    </Radio>
  )
}
